import { z } from 'zod';
import { PUSH_SERVICE_HOST_SUFFIXES } from '../constants';

const base64url = (min: number, max: number) =>
  z.string().min(min).max(max).regex(/^[A-Za-z0-9_-]+=*$/, 'Nieprawidłowy klucz subskrypcji.');

export function isAllowedPushEndpoint(value: string): boolean {
  try {
    const url = new URL(value);
    const host = url.hostname.toLowerCase();
    return url.protocol === 'https:' && PUSH_SERVICE_HOST_SUFFIXES.some((s) => host.endsWith(s) || host === s.slice(1));
  } catch {
    return false;
  }
}

/** PushSubscription.toJSON() as sent by the browser. */
export const pushSubscriptionSchema = z.object({
  endpoint: z
    .string()
    .max(1024)
    .refine(isAllowedPushEndpoint, 'Ta przeglądarka używa nieobsługiwanej usługi powiadomień.'),
  expirationTime: z.number().nullable().optional(),
  keys: z.object({
    p256dh: base64url(40, 255),
    auth: base64url(8, 255),
  }),
});
export type PushSubscriptionRequest = z.input<typeof pushSubscriptionSchema>;

export const pushUnsubscribeSchema = z.object({ endpoint: z.string().max(1024) });
